<mat-toolbar color="primary">
        Save
</mat-toolbar>
<mat-dialog-content class="mat-typography">
    <h6>{{ details.message }}</h6>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>No</button>
    <button mat-raised-button color="primary" (click)="handleStatusChangeAction()">Yes</button>
</mat-dialog-actions>